import { ModeOfTravelEnum, PassengerTypeEnum, PaxRuleEnum } from "@/models/enums";
import { destinations, stringRoutes } from "./global.strings";

export const allRules: Rules[] = [
	{
		modeOfTravel: ModeOfTravelEnum.Scillonian,
		ports: [
			{
				code: destinations.PZE,
				destinations: [
					{
						code: destinations.ISC
					}
				],
			},
			{
				code: destinations.ISC,
				destinations: [
					{
						code: destinations.PZE
					}
				]
			}

		],
		paxRules: [
			{
				type: PaxRuleEnum.MaxAmount,
				amount: 15,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.PZEISC
					}
				],
				text: "For bookings of more than 15 people, please call our travel centre on: 01736 334220 to receive group discount."
			},
			{
				type: PaxRuleEnum.MaxPerAdult,
				amount: 2,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.PZEISC
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Dog
					}
				],
				text: "You cannot add more than two dogs per adult to this booking. To book more than two dogs per adult please call our travel centre on 01736 334220."
			},
			{
				type: PaxRuleEnum.Mandatory,
				amount: 1,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.PZEISC
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Adult
					},
					{
						type: PassengerTypeEnum.ShareholderAdult
					}
				],
				text: "Children, infants and dogs must be accompanied by at least 1 adult. To book unaccompanied minors please call our travel centre on 01736 334220."
			}
		]
	},
	{
		modeOfTravel: ModeOfTravelEnum.Skybus,
		ports: [
			{
				code: destinations.LEQ,
				destinations: [
					{
						code: destinations.ISC
					}
				]
			},
			{
				code: destinations.EXT,
				destinations: [
					{
						code: destinations.ISC
					}
				]
			},
			{
				code: destinations.NQY,
				destinations: [
					{
						code: destinations.ISC
					}
				]
			},
			{
				code: destinations.ISC,
				destinations: [
					{
						code: destinations.LEQ,
					},
					{
						code: destinations.EXT,
					},
					{
						code: destinations.NQY
					}
				]
			}
		],
		paxRules: [
			{
				type: PaxRuleEnum.Forbidden,
				routes: [
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Dog
					}
				],
				text: "We are not able to accept dogs on flights to or from Exeter Airport. Dogs can be booked onto flights from Newquay and Land’s End Airport. Guide dogs are accepted on all Skybus flights."
			},
			{
				type: PaxRuleEnum.Mandatory,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Adult
					},
					{
						type: PassengerTypeEnum.ShareholderAdult
					}
				],
				text: "Children, infants and dogs must be accompanied by at least 1 adult. To book unaccompanied minors please call our travel centre on 01736 334220."
			},
			{
				type: PaxRuleEnum.MaxPerAdult,
				amount: 1,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Infant
					}
				],
				text: "You cannot add more than one infant per adult to this booking. To book more than one infant per adult please call our travel centre on 01736 334220"
			},
			{
				type: PaxRuleEnum.MaxPerAdult,
				amount: 3,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Child
					}
				],
				text: "Maximum 3 children per adult on Skybus"
			},
			{
				type: PaxRuleEnum.MaxAmountPassengerType,
				amount: 1,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Dog
					}
				],
				text: "If you have more than one dog please call our travel centre on 01736 334220 to book."
			},
			{
				type: PaxRuleEnum.MaxAmount,
				amount: 8,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				text: "Group bookings of 8 or more passengers per reservation cannot be booked online. For group bookings please call our travel centre on 01736 334220"
			},
		]
	},
	{
		modeOfTravel: ModeOfTravelEnum.FlyAndSail,
		ports: [
			{
				code: destinations.LEQISC,
				outwardOnly: true,
				destinations: [
					{
						code: destinations.ISCPZE
					}
				]
			},
			{
				code: destinations.ISCPZE,
				returnOnly: true,
				destinations: [
					{
						code: destinations.PZE
					}
				]
			}
		],
		paxRules: [
			{
				type: PaxRuleEnum.Mandatory,
				amount: 1,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Adult	
					},
					{
						type: PassengerTypeEnum.ShareholderAdult
					}
				],
				text: "Children, infants and dogs must be accompanied by at least 1 adult. To book unaccompanied minors please call our travel centre on 01736 334220."
			}
		]
	},
	{
		modeOfTravel: ModeOfTravelEnum.SailAndFly,
		ports: [			
			{
				code: destinations.PZEISC,
				outwardOnly: true,
				destinations: [
					{
						code: destinations.ISCLEQ
					}
				]
			},
			{
				code: destinations.ISCLEQ,
				returnOnly: true,
				destinations: [
					{
						code: destinations.PZEISC
					}
				]
			}
		],
		paxRules: [
			{
				type: PaxRuleEnum.Mandatory,
				amount: 1,
				routes: [
					{
						code: stringRoutes.ISCPZE
					},
					{
						code: stringRoutes.PZEISC
					},
					{
						code: stringRoutes.LEQISC
					},
					{
						code: stringRoutes.ISCLEQ
					},
					{
						code: stringRoutes.STMLEQ
					},
					{
						code: stringRoutes.LEQSTM
					},
					{
						code: stringRoutes.EXTISC
					},
					{
						code: stringRoutes.ISCEXT
					},
					{
						code: stringRoutes.NQYISC
					},
					{
						code: stringRoutes.ISCNQY
					}
				],
				passengerTypes: [
					{
						type: PassengerTypeEnum.Adult	
					},
					{
						type: PassengerTypeEnum.ShareholderAdult
					}
				],
				text: "Children, infants and dogs must be accompanied by at least 1 adult. To book unaccompanied minors please call our travel centre on 01736 334220."
			}
		]
	}
]

export interface Rules {
	ports: Port[];
	modeOfTravel: ModeOfTravelEnum;
	paxRules: PaxRule[];
}

export interface Port {
	code: string;
	outwardOnly?: boolean;
	returnOnly?: boolean;
	destinations: Route[];
}

export interface Route {
	code: string;
}

export interface PaxRule {
	type: PaxRuleEnum;
	amount?: number;
	routes: Route[];
	passengerTypes?: PassengerType[];
	text: string;
}

export interface PassengerType {
	type: PassengerTypeEnum;
}